import './dot.scss'
const addCartAnimate = function (startEl, targetEl) {
  const dotWidth = 20
  const div = document.createElement('div')
  div.className = 'add-cart-animate-container'
  const icon = document.createElement('span')
  icon.className = 'add-cart-animate-dot'
  div.appendChild(icon)
  const startBtnRect = startEl.getBoundingClientRect()
  let left = startBtnRect.left + startBtnRect.width / 2
  let top = startBtnRect.top + startBtnRect.height / 2
  div.style.left = left + 'px'
  div.style.top = top + 'px'
  const targetBtnRect = targetEl.getBoundingClientRect()
  let x = targetBtnRect.left + targetBtnRect.width / 2 - left - dotWidth / 2
  let y = targetBtnRect.top + targetBtnRect.height / 2 - top - dotWidth / 2
  let animateTime = Math.round(y / 100) / 10
  animateTime = animateTime <= 0 ? 0.1 : animateTime
  icon.style.animation = `addCartAnimateY ${animateTime}s cubic-bezier(0.5,-0.5,1,1)`
  div.style.animation = `addCartAnimateX ${animateTime}s linear`
  div.style.setProperty('--x', `${x}px`)
  div.style.setProperty('--y', `${y}px`)
  div.addEventListener('animationend', () => {
    div.remove()
  })
  document.body.appendChild(div)
}
export { addCartAnimate }
